// extracted by mini-css-extract-plugin
export default {"vehicle-form":"vehicle-form_vehicle-form__ggHpw","input-control":"vehicle-form_input-control__WIdfw"};